export default "__VITE_ASSET__aSZDy_aa__"